module.exports = __webpack_public_path__ + "static/img/liveRanking.e25bdc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rank/liveRanking.png
// module id = xSBO
// module chunks = 0